import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import {
  HContainer,
  Image,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  HandleRender
} from 'hocs';

import {
  printCurrency
} from 'helpers';

import {
  useCatalogue
} from '../hooks';

import {
  CustomColors
} from '../../../../constants';

export const VendorCard = (props) => {

  const catalogue = useCatalogue(props.vendorId);

  const Content = () => {

    const subTitle = `Vouchers from ${printCurrency(catalogue.content?.lowestPrice)}`;

    return (
      <>
        <HContainer
          maxWidth={props.imageMaxWidth}
          maxHeight={props.imageMaxHeight}
          width={'45%'}>

          <Image
            objectFit={'cover'}
            src={catalogue.content?.vendorImage}
            width={props.imageWidth}
            height={props.imageHeight}/>
        </HContainer>

        <VContainer
          margin={'auto 8px'}>

          <HContainer
            maxWidth={props.logoMaxWidth}>

            <Image
              objectFit={'cover'}
              src={catalogue.content?.attachment?.logo}
              width={props.logoWidth}
              height={props.logoHeight}/>
          </HContainer>

          <Text
            fontSize={props.titleSize}
            color={props.titleColor}
            fontWeight={props.titleWeight}
            lineHeight={props.titleLineHeight}>

              {catalogue.content?.name}
          </Text>

          <Text
            fontSize={props.subtitleSize}
            color={props.subtitleColor}
            fontWeight={props.subtitleWeight}
            lineHeight={props.subtitleLineHeight}>

              {subTitle}
          </Text>
        </VContainer>
      </>
    );
  };

  return (
    <>
      { !catalogue.isError &&

        <HContainer
          width={props.cardWidth}
          height={props.cardHeight}
          maxHeight={props.cardMaxHeight}
          maxWidth={props.cardMaxWidth}
          margin={props.margin}
          boxShadow={props.boxShadow}
          overflow={'hidden'}
          borderRadius={props.borderRadius}
          onClick={() => !catalogue.isLoading && props.onClick?.()}>

          <HandleRender
            isLoading={catalogue.isLoading}
            isError={catalogue.isError}
            loader={{ size: '140' }}>

            <Content/>
          </HandleRender>
        </HContainer>
      }
    </>
  );
};

VendorCard.propTypes = {
  borderRadius: PropTypes.string,
  boxShadow: PropTypes.string,
  cardHeight: PropTypes.string,
  cardMaxHeight: PropTypes.string,
  cardMaxWidth: PropTypes.string,
  cardWidth: PropTypes.string,
  imageHeight: PropTypes.string,
  imageMaxHeight: PropTypes.string,
  imageMaxWidth: PropTypes.string,
  imageWidth: PropTypes.string,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  logo: PropTypes.string,
  logoHeight: PropTypes.string,
  logoMaxWidth: PropTypes.string,
  logoWidth: PropTypes.string,
  margin: PropTypes.string,
  subtitleColor: PropTypes.string,
  subtitleLineHeight: PropTypes.string,
  subtitleSize: PropTypes.string,
  subtitleWeight: PropTypes.string,
  title: PropTypes.string,
  titleColor: PropTypes.string,
  titleLineHeight: PropTypes.string,
  titleSize: PropTypes.string,
  titleWeight: PropTypes.string,
  onClick: PropTypes.func
};

VendorCard.defaultProps = {
  borderRadius: '8px',
  boxShadow: `0px 4px 4px ${CustomColors.TransparentBlack1}`,
  cardHeight: '150px',
  cardMaxHeight: '150px',
  cardMaxWidth: '100%',
  cardWidth: '100%',
  imageHeight: '100%',
  imageMaxHeight: '100%',
  imageMaxWidth: '150px',
  imageWidth: '100%',
  isError: false,
  isLoading: true,
  logo: '',
  logoHeight: '100%',
  logoMaxWidth: '54px',
  logoWidth: '100%',
  margin: '8px 0',
  subtitleColor: CustomColors.Grey7,
  subtitleLineHeight: '16px',
  subtitleSize: '14px',
  subtitleWeight: '400',
  title: 'Title',
  titleColor: CustomColors.Black, // TODO: I don't know what this should be,
  titleLineHeight: '23px',
  titleSize: '20px',
  titleWeight: '700',
  onClick: () => {}
};
